/**
 * gold = own contribution (collected by flying through it), bonus = Grundzulage (pulled to the figure),
 * special = a special coin (once a round, collected like a gold coin)
 */
export type CoinKind = 'gold' | 'bonus' | 'special';

/**
 * When the gold coins of a life reach the figure (life time in s, in order). The bonus coins are not planned:
 * they are earned (shared/scoring.ts, BONUS_COIN_AFTER) and come in the next stretch not in view yet.
 */
export interface CoinPlan {
  at: number[];
  /** time between two coins */
  gap: number;
  minGap: number;
}

export function emptyPlan(count: number, minGap: number): CoinPlan {
  return { at: new Array<number>(count).fill(0), gap: minGap, minGap };
}

/** Spread the coins from `from` on evenly between `start` and `end` (at least `minGap` apart). */
export function spreadCoins(plan: CoinPlan, from: number, start: number, end: number): void {
  const n = plan.at.length - from;
  if (n <= 0) return;
  if (n > 1) plan.gap = Math.max(plan.minGap, (end - start) / (n - 1));
  for (let i = 0; i < n; i++) plan.at[from + i] = start + i * plan.gap;
}
